import { CreateTransient, Icon } from "@mindlercare/ui-web";
import { styled } from "styled-components";
import { HighlightStatus } from "./types";

export const IconTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const highlightColor = {
  info: "ACTION_BLUE",
  none: "GRAY",
  alert: "ERROR",
} as const;

export const CheckCircleIcon = styled(Icon.CheckCircle)<
  CreateTransient<{ highlight?: HighlightStatus }>
>`
  color: ${({ theme, $highlight }) =>
    $highlight ? theme.COLORS[highlightColor[$highlight]] : theme.COLORS.BLACK};
`;

export const AssignmentIcon = styled(Icon.Assignment)<
  CreateTransient<{ highlight?: HighlightStatus }>
>`
  color: ${({ theme, $highlight }) =>
    $highlight ? theme.COLORS[highlightColor[$highlight]] : theme.COLORS.BLACK};
`;

export const LockIcon = styled(Icon.Lock)`
  color: ${({ theme }) => theme.COLORS.ERROR};
`;
